// api/apiClient.ts
import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://gg-api.nationtonation.ca/api",
  withCredentials: true, 
});


// 🔐 Always attach latest token before each request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let subscribers: Array<(token: string) => void> = [];

const onTokenRefreshed = (token: string) => {
  subscribers.forEach((callback) => callback(token));
  subscribers = [];
};

const addSubscriber = (callback: (token: string) => void) => {
  subscribers.push(callback);
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const response = await axios.post(
  "https://gg-api.nationtonation.ca/api/auth/refresh",
  {},
  { withCredentials: true }
);


          const newToken = response.data.token;
          localStorage.setItem("token", newToken);
          isRefreshing = false;

          onTokenRefreshed(newToken);
          return apiClient(originalRequest);
        } catch (refreshError) {
          handleLogout();
          return Promise.reject(refreshError);
        }
      }

      return new Promise((resolve) => {
        addSubscriber((token: string) => {
          originalRequest.headers["Authorization"] = `Bearer ${token}`;
          resolve(apiClient(originalRequest));
        });
      });
    }

    return Promise.reject(error);
  }
);

const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  window.location.href = "/login";
};

export default apiClient;
